import type { IPolicy } from '@adornis/abac/core/types.js';
import type { UserWithPermissionFields } from '../UserWithPermissionFields.js';
import type { MartinusAbacPayload } from './MartinusAbacPayload.js';

export type PayloadWithUser<P extends MartinusAbacPayload> = Omit<P, 'currentUser'> & {
  currentUser: UserWithPermissionFields;
};

export type RequestWithUser<P extends MartinusAbacPayload> = {
  payload: PayloadWithUser<P>;
};

export type LoggedInEvaluationFunction<P extends MartinusAbacPayload> = (
  request: RequestWithUser<P>,
) => ReturnType<IPolicy<P>['evaluate']>;

const loggedIn = (currentUser: MartinusAbacPayload['currentUser']): UserWithPermissionFields => {
  if (!currentUser) throw new Error('Nicht eingeloggt');
  return currentUser;
};

/**
 * Ensures the payload has a logged in user. Throws if not so the policy engine can handle denial
 * @param payload A payload with a user or no user
 * @returns a payload with a user
 */
export function ensureLoggedInPayload<P extends MartinusAbacPayload = MartinusAbacPayload>(
  payload: P,
): PayloadWithUser<P> {
  return {
    ...payload,
    currentUser: loggedIn(payload.currentUser),
  };
}
